/**
 *  should map to Mojo.Client.Core.Domain.Models.SystemConfiguration
 */
import {SystemSettingsDto} from './mojo-system-settings-model';
import {SelectItem} from 'primeng/api';
import {
  ListerColumnConfig
} from '@admin/containers/system-configuration-page/sections/lister-configuration/lister-configuration.types';

export class GeneralInformation {
  public applicationName: string;
  public emailSignature: string;
  public supportTelNo: string;
  public supportEmailAddress: string;
  public companyWebSite: string;
}

export class OverviewConfiguration {
  public selectedTiles: SelectItem[];
  public displayNonCurrentManagers?: boolean;
  public skipListerPage?: boolean;
  public displayObsoleteUnits?: boolean;
  public selectedFilterField: string;
  public selectedFilterFieldItems: number[];
  public displayNonCurrentLeasesAndTenants?: boolean;
  public displayNonCurrentHeadLeasesAndLandlords?: boolean;
}

export class SmtpModel {
  public HostName: string;
  public Port: number;
  public Password: string;
  public SenderEmail: string;
  public SenderName: string;
  public EnableSsl: string;
}

export class SystemConfigModel {
  public BrandInformation: GeneralInformation;
  public OverviewConfig: OverviewConfiguration;
  public ListerConfiguration: ListerConfiguration;
}

export class ListerConfiguration {
  config: ListerColumnConfig[]
}

export class GetInvoiceLoggingAndSuggestedCodingResponse {
  InvoiceLoggingAndSuggestedCodingDto: InvoiceLoggingAndSuggestedCodingDto;
}

export class InvoiceLoggingAndSuggestedCodingDto {
  public DefaultCreditorInvoiceDocumentTypeCode: string;
  public AllowSuggestedCoding: boolean;
  public AnalysisPeriod: number;
  public CreditorPropertyThreshold: number;
  public ExpenseAnalysisThreshold: number;
  public ExpenseCodeThreshold: number;
}

export class InvoiceLoggingAndSuggestedCoding {
  public DefaultCreditorInvoiceDocumentTypeCode: TransactionType;
  public AllowSuggestedCoding: boolean;
  public AnalysisPeriod: number;
  public CreditorPropertyThreshold: number;
  public ExpenseAnalysisThreshold: number;
  public ExpenseCodeThreshold: number;
}

export class SaveInvoiceLoggingAndSuggestedCodingRequest {
  InvoiceLoggingAndSuggestedCodingDto: InvoiceLoggingAndSuggestedCodingDto;
}

export class SaveInvoiceLoggingAndSuggestedCodingResponse {
  Success: boolean;
  ValidationResults: ValidationResultsDto;
}

export class ValidationResultsDto {
  IsSuccess: boolean;
  RuleResults: ValidationRuleResultsDto[];
}

export class ValidationRuleResultsDto {
  AssociatedProperty: string;
  FailureMessage: string;
  IsSuccess: string;
}

export class TransactionType {
  Code: string;
  Description: string;
}

export interface SecurityGroup {
  Name: string;
  Value: string;
}

export interface ApprovalGroupDto {
  Uri?: number;
  Name: string;
  IsDeletionAllowed: boolean;
  SecurityGroupCodes: string[];
}

export interface ApprovalGroup {
  Uri?: number;
  Name: string;
  IsDeletionAllowed: boolean;
  SecurityGroupCodes: SecurityGroup[];
}

export class MojoSystemConfigModel {
  public BrandInformation: GeneralInformation;
  public ActivitySettings: SystemSettingsDto;
  public OverviewConfig: OverviewConfiguration;
  public ApprovalGroups: ApprovalGroup[];
}
